import { render, staticRenderFns } from "./Utrecht.vue?vue&type=template&id=55599926&"
var script = {}
import style0 from "./Utrecht.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Utrecht.vue"
export default component.exports